/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { send } from 'xstate';
const INITIAL_CONTEXT = {
  idle: {},
  CHECK_USER_LOGIN: {},
  SEND_OTP: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.BuyInsurancePage.get-kyc-data',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'CHECK_USER_LOGIN' },
      },
    },
    CHECK_USER_LOGIN: {
      invoke: {
        id: 'checkUserLogin',
        src: 'checkUserLogin',
        onDone: {
          target: 'USER_LOGIN_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'USER_IS_NOT_LOGGED_IN',
          actions: ['failureAction'],
        },
      },
    },
    USER_LOGIN_SUCCESS: {
      invoke: {
        id: 'getKYCFormData',
        src: 'getKYCFormData',
        onDone: {
          target: 'KYC_FORM_DATA_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'KYC_FORM_DATA_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    USER_IS_NOT_LOGGED_IN: {
      on: {
        SEND_OTP: {
          target: 'SEND_EMAIL_OTP',
        },
      },
    },
    SEND_EMAIL_OTP: {
      invoke: {
        id: 'sendOTP',
        src: 'sendOTP',
        onDone: {
          target: 'SUBMIT_OTP',
          actions: ['successAction'],
        },
        onError: {
          target: 'SUBMIT_OTP_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    SUBMIT_OTP: {
      on: {
        VERIFY_OTP: {
          target: 'VERIFY_OTP',
        },
        SEND_OTP: {
          target: 'SEND_EMAIL_OTP',
        },
      },
    },
    VERIFY_OTP: {
      invoke: {
        id: 'signInUser',
        src: 'signInUser',
        onDone: {
          target: 'CHECK_TOKEN_TYPE',
          actions: ['successAction'],
        },
        onError: {
          target: 'USER_IS_NOT_LOGGED_IN',
          actions: ['failureAction'],
        },
      },
    },
    CHECK_TOKEN_TYPE: {
      entry: send('CHECK_TOKEN_TYPE', { to: 'checkTokenType' }),
      invoke: {
        id: 'checkTokenType',
        src: 'checkTokenType',
      },
      on: {
        SIGN_IN_TOKEN: {
          target: 'GET_ACCESS_TOKEN',
          actions: ['successAction'],
        },
        ACCESS_TOKEN: {
          target: 'USER_LOGIN_SUCCESS',
          actions: ['successAction'],
        },
        ERROR: {
          target: 'USER_IS_NOT_LOGGED_IN',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_ACCOUNT_SELECTION: {
      entry: (context: any, event: any) => {
        console.log('render account selection event =>', context);
      },
      on: {
        GET_ACCESS_TOKEN: {
          target: 'GET_ACCESS_TOKEN',
          actions: ['successAction'],
        },
      },
    },
    GET_ACCESS_TOKEN: {
      invoke: {
        id: 'getAccessToken',
        src: 'getAccessToken',
        onDone: {
          target: 'USER_LOGIN_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'USER_IS_NOT_LOGGED_IN',
          actions: ['failureAction'],
        },
      },
    },
    SUBMIT_OTP_FAILED: {
      on: {
        SEND_OTP: {
          target: 'SEND_EMAIL_OTP',
        },
      },
    },
    VERIFY_OTP_FAILED: {
      on: {
        VERIFY_OTP: {
          target: 'VERIFY_OTP',
        },
      },
    },
    KYC_FORM_DATA_SUCCESS: {
      type: 'final',
    },
    KYC_FORM_DATA_ERROR: {
      on: {
        START: { target: 'CHECK_USER_LOGIN' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
